export { COLLECTION_ITEM_SIGN, createCollectionWithScope } from './src/collection.mjs';
import './src/tokens.mjs';
//# sourceMappingURL=index.mjs.map
